// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"PriceDate_icomoon-font__oSXN4","PriceDateHolder":"PriceDate_PriceDateHolder__NW0bV","AlertClass":"PriceDate_AlertClass__Bnpnb"};